import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable, inject } from '@angular/core';
import { delay, mergeMap } from 'rxjs/operators';
import { SpxStorage, SpxStorageKeyEnum } from '@softpak/components/spx-storage';

import { AmqTriggerActions } from './amq-trigger.actions';
import { statsActionActions } from '../stats-action';

@Injectable()
export class AmqTriggerEffects {
    private readonly actions$ = inject(Actions);

    private readonly _afterSubmitLiftOfTruck$ = createEffect(() =>
        this.actions$.pipe(
            ofType(AmqTriggerActions.submitLiftOffTruck),
            delay(1000),
            mergeMap((action) => [
                this.createStatsAction('AMQ_SUBMIT_LIFT_OFF_TRUCK', {
                    containerSequenceNumber: action.containerSequenceNumber,
                    orderSequenceNumber: action.orderSequenceNumber,
                }),
                AmqTriggerActions.reset(),
            ])
        )
    );

    private readonly _afterSubmitPlaceInStack$ = createEffect(() =>
        this.actions$.pipe(
            ofType(AmqTriggerActions.submitPlaceInStack),
            delay(1000),
            mergeMap((action) => [
                this.createStatsAction('AMQ_SUBMIT_PLACE_IN_STACK', {
                    containerSequenceNumber: action.containerSequenceNumber,
                    orderSequenceNumber: action.orderSequenceNumber,
                }),
                AmqTriggerActions.reset(),
            ])
        )
    );

    private readonly _afterSubmitPlaceOnTruck$ = createEffect(() =>
        this.actions$.pipe(
            ofType(AmqTriggerActions.submitPlaceOnTruck),
            delay(1000),
            mergeMap((action) => [
                this.createStatsAction('AMQ_SUBMIT_PLACE_ON_TRUCK', {
                    containerSequenceNumber: action.containerSequenceNumber,
                    orderSequenceNumber: action.orderSequenceNumber,
                }),
                AmqTriggerActions.reset(),
            ])
        )
    );

    private readonly _afterSubmitRelocateOrder$ = createEffect(() =>
        this.actions$.pipe(
            ofType(AmqTriggerActions.submitRelocateOrder),
            delay(1000),
            mergeMap((action) => [
                this.createStatsAction('AMQ_SUBMIT_RELOCATE_ORDER', {
                    containerSequenceNumber: action.containerSequenceNumber,
                    orderSequenceNumber: action.orderSequenceNumber,
                }),
                AmqTriggerActions.reset(),
            ])
        )
    );

    private readonly _afterTriggerStartRelocate$ = createEffect(() =>
        this.actions$.pipe(
            ofType(AmqTriggerActions.startRelocate),
            delay(1000),
            mergeMap((action) => [
                this.createStatsAction('AMQ_START_RELOCATE', {
                    containerSequenceNumber: action.containerSequenceNumber,
                    orderSequenceNumber: action.orderSequenceNumber,
                }),
                AmqTriggerActions.reset(),
            ])
        )
    );

    private readonly _afterTriggerSubmitStandardRelocate$ = createEffect(() =>
        this.actions$.pipe(
            ofType(AmqTriggerActions.submitStandardRelocate),
            delay(1000),
            mergeMap((action) => [
                this.createStatsAction('AMQ_SUBMIT_STANDARD_RELOCATE', {
                    containerSequenceNumber: action.containerSequenceNumber,
                }),
                AmqTriggerActions.reset(),
            ])
        )
    );

    private createStatsAction(action: string, actionData?: Record<string, unknown>) {
        const cleanedActionData = actionData == null
            ? undefined
            : Object.fromEntries(Object.entries(actionData).filter(([, value]) => value != null));

        return statsActionActions.load({
            query: {
                app: 'orders',
                customer: SpxStorage.getSetting(SpxStorageKeyEnum.brand),
                action,
                actionData: cleanedActionData && Object.keys(cleanedActionData).length > 0 ? cleanedActionData : undefined,
                randomDeviceId: SpxStorage.getSetting(SpxStorageKeyEnum.randomDeviceId),
                username: SpxStorage.getSetting(SpxStorageKeyEnum.username),
            },
        });
    }
}
